export default "__VITE_ASSET__CeLTRuOB__"